const ANAKATECH_CODE_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
const OFFSET_MILLISECONDS = 5 * 60 * 60 * 1000;

export function parseLocalTimeToEpochMilliseconds(value) {
  const normalized = String(value ?? "").trim();
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?$/.test(normalized)) {
    return Number.NaN;
  }

  const dateTimeWithSeconds = normalized.length === 16
    ? `${normalized}:00`
    : normalized;
  return new Date(`${dateTimeWithSeconds}-05:00`).getTime();
}

export function formatEpochAsLimaDateTime(value) {
  if (value === null || value === undefined || value === "") return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Date(date.getTime() - OFFSET_MILLISECONDS)
    .toISOString()
    .slice(0, 16);
}

export function restoreAnakatechFreeSpinListDate(value) {
  if (value === null || value === undefined || value === "") return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Date(date.getTime() + OFFSET_MILLISECONDS).toISOString();
}

export function generateAnakatechFreeRoundCode(clientCode, random = Math.random) {
  const normalizedClientCode = String(clientCode ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

  if (!normalizedClientCode) {
    throw new Error("clientCode is required to generate the Free Round code.");
  }

  const suffix = Array.from({ length: 12 }, () => {
    const index = Math.floor(random() * ANAKATECH_CODE_ALPHABET.length);
    return ANAKATECH_CODE_ALPHABET[index];
  }).join("");

  return `ANK${normalizedClientCode}${suffix}`;
}
